import { CaretRightOutlined, RightOutlined } from "@ant-design/icons";
import {
    Collapse,
    Row,
    Col,
    Steps,
    Button,
    message,
    Form,
    Input,
    Image,
    Carousel,
    Card,
    Divider,
    Select,
    DatePicker,
    Radio,
    Checkbox,
    Space,
    Avatar,
    Spin,
    Tag
} from "antd";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";


import { ADD_MODE, DATE_FORMAT_DMY_SLASH, EDIT_MODE, ROUND_OFF_ACCOUNT_ID, SAVE_SUCCESS_MSG, SUCCESS_STATUS, UPDATE_SUCCESS_MSG } from "../../utility/Constants";
import ModalWithMessageAndAction from "../common/ModalWithMessageAndAction";

import moment from "moment";
import commonUtility from "../../utility/Utils";
// import AccountDrCrDetails from "../accountdetails/AccountDrCrDetails";
import accountService from "../../api/account.service";
import Meta from "antd/lib/card/Meta";
import purchaseService from "../../api/purchase.service";
import TaxInvoiceDetailView from "./TaxInvoiceDetailView";
import taxInvoiceService from "../../api/taxinvoice.service";

const { Option } = Select;
const { TextArea } = Input;

const dividerStyle = {
    margin:'4px 0'
}

const defaultFormValues = {
    salebill_id: 0,
    invoice_number: "",
    invoice_date: "",
    mode: "ADD",
    customer_account_id: "",
    voucher_id: 0,
    dr_ac_id: "",
    total_taxable: 0,
    total_cgst: 0,
    total_sgst: 0,
    total_igst: 0,
    total_gst: 0,
    gst_including_amount: 0,
    round_off_amount: 0,
    round_off_account_id: ROUND_OFF_ACCOUNT_ID,
    net_amount: 0,
    sale_detail: []
};




const TaxInvoiceEntryView = () => {

    const [accountList, setAccountList] = useState([]);
    const [customerList, setCustomerList] = useState([]);


    const [form] = Form.useForm();
    const [openModal, setOpenModal] = useState(false);
    const [responseModalTitle, setResponseModalTitle] = useState("");
    const [responseModalMessage, setResponseModalMessage] = useState("");
    const [formErrorMessage, setFormErrorMessage] = useState("");
    const [isSaveLoaderEnable, setSaveLoaderEnable] = useState(false);

    const [summaryAmountDetails, setSummaryAmountDetails] = useState({
        totalAmount:0,
        totalDiscount:0,
        totalTaxable:0,
        totalCGST:0,
        totalSGST:0,
        totalIGST:0,
        totalGST:0,
        totalNetAmountWithGST:0,
        round_off_amount:0,
        netAmountAfterRoundOff:0,
    });
    const [totalCreditAmount, setTotalCreditAmount] = useState(0);

    const [responseModal, setResponseModal] = useState({
        responseModalTitle: '',
        isOpenModal: false,
        listLink: '',
        addmoreLink: '',
        responseModalMessage: '',
        printReuired: false
    });


    const params = useParams();

    const onTaxInvoiceSave = async (values) => {
    console.log('values',values);
   // return false;
                 setResponseModal({
                    responseModalTitle: '',
                    isOpenModal: false,
                    listLink: '',
                    addmoreLink: '',
                    responseModalMessage: '',
                    printReuired: false
                });

         
                if(values.sale_detail.length >0){


             

                    setSaveLoaderEnable(true)
                    const data = { formdata: values };
                    const response = taxInvoiceService.taxInvoiceSave(data).then((resdata) => {
                        let resdt = resdata.data.response_data;
                        if(values.mode == ADD_MODE){
                            setResponseModal({
                                responseModalTitle: 'Success',
                                isOpenModal: true,
                                listLink: '/taxinvoice/list',
                                addmoreLink: '/taxinvoice/entry',
                                responseModalMessage: `${resdt.invoice_no} saved successfully`,
                                printReuired: false
                            });
                        }
                        else if(values.mode == EDIT_MODE) {
                            setResponseModal({
                                responseModalTitle: 'Success',
                                isOpenModal: true,
                                listLink: '/taxinvoice/list',
                                addmoreLink: '/taxinvoice/entry',
                                responseModalMessage: `Tax Invoice ${values.invoice_number} updated successfully`,
                                printReuired: false
                            });
                        }
                        setSaveLoaderEnable(false)
    
                        /*
                        if (resdata.response_data.mode == ADD_MODE) {
                            setResponseModal({
                                responseModalTitle: 'Success',
                                isOpenModal: true,
                                listLink: '/journalvoucher/list',
                                addmoreLink: '/journalvoucher/entry',
                                responseModalMessage: `${SAVE_SUCCESS_MSG} with voucher no ${resdata.response_data.voucher_no}`,
                                printReuired: false
                            });
                        }
                        else if (resdata.response_data.mode == EDIT_MODE) {
                            setResponseModal({
                                responseModalTitle: 'Success',
                                isOpenModal: true,
                                listLink: '/journalvoucher/list',
                                addmoreLink: '/journalvoucher/entry',
                                responseModalMessage: `${UPDATE_SUCCESS_MSG}`,
                                printReuired: false
                            });
                        }
                        setSaveLoaderEnable(false)
                        */
                        
                    });
                }
                else{
                    commonUtility.openNotificationWithType("error","rightBottom","Error","Please add atleast one tax invoice detail.");
                    setSaveLoaderEnable(false)
                }

               
            
        
        
    };

    const handleCancel = () => {
        setOpenModal(false);
    };



  


    const onDateChange = (date, dateString) => {
        form.setFieldsValue({
            invoice_date: dateString,
        });
    };



    useEffect(() => {
        accountService.accountList().then((res) => {
          setAccountList(res.data.response_data);
        });
      }, []);


      

      useEffect(() => {
        accountService.customerList().then((res) => {
            setCustomerList(res.response_data);
        });
      }, []);





    useEffect(()=>{
        
        //TaxInvoice Edit

        console.log('taxinvoice',params.salebill_id);

        if (params.salebill_id && params.salebill_id > 0) {
            const data = {
                formdata: {
                    salebill_id: params.salebill_id,
                },
            };


            const response = taxInvoiceService.taxInvoiceGetByID(data).then((resdata) => {

                if (resdata.data.response_status === SUCCESS_STATUS) {
                    
                    let taxinvoice_data = resdata.data.response_data;
                    let taxInvoiceMasterData = taxinvoice_data.masterData[0];

                    form.setFieldsValue({
                        salebill_id: taxInvoiceMasterData.salebill_id,
                        invoice_number: taxInvoiceMasterData.invoice_number,
                        invoice_date: taxInvoiceMasterData.invoice_date,
                        invoice_date: taxInvoiceMasterData.invoice_date,
                        invoice_date_picker: taxInvoiceMasterData.invoice_date ? moment(taxInvoiceMasterData.invoice_date, DATE_FORMAT_DMY_SLASH) : '',
                        mode: "EDIT",
                        customer_account_id: taxInvoiceMasterData.customer_account_id,
                        voucher_id: taxInvoiceMasterData.voucher_master_id,
                        //dr_ac_id: purchaseMasterData.invoice_number,
                        total_taxable: taxInvoiceMasterData.total_taxable_amount,
                        total_cgst: taxInvoiceMasterData.total_cgst_amount,
                        total_sgst: taxInvoiceMasterData.total_sgst_amount,
                        total_igst: taxInvoiceMasterData.total_igst_amount,
                        total_gst: taxInvoiceMasterData.total_gst_amount,
                        gst_including_amount: taxInvoiceMasterData.total_amount,
                        round_off_amount: taxInvoiceMasterData.round_off_amount,
                        net_amount: taxInvoiceMasterData.net_payble_amount,
                        
                    });
 
                    

                    let taxInvoiceDetailList = taxinvoice_data.detailsData;

                    let obj = [];
                    taxInvoiceDetailList.map((e) => {
                        const x = {
                            cr_ac_id : e.cr_ac_id,
                            hsn: e.hsn,
                            unit:e.unit,
                            qty:e.qty,
                            rate_per_unit:e.rate_per_unit,
                            item_value:e.item_value,
                            discount:e.discount,
                            taxable_amount:e.taxable_amount,
                            cgst_id:e.cgst_id,
                            cgst_amount:e.cgst_amount,
                            sgst_id:e.sgst_id,
                            sgst_amount:e.sgst_amount,
                            igst_id:e.igst_id,
                            igst_amount:e.igst_amount,
                            total_gst_amount:e.total_gst_amount,
                            net_amount:e.net_amount,
                        };

                        obj.push(x);
                    });
  
                     form.setFieldsValue({ sale_detail: obj });
                     onFormCalculation();
                }
                
              
            });



        }


    },[params]);
  
      


    const onFormCalculation = () => {
        setFormErrorMessage("")
            
            let sale_detail = form.getFieldValue("sale_detail");




            let total_amount_with_gst = 0;
            let total_gst = 0;
            

            // let total_amount = purchase_details.reduce((a, v) => a = a + parseFloat(v?.item_value), 0);
            // let total_cgst_amt = purchase_details.reduce((a, v) => a = a + parseFloat(v?.cgst_amount), 0);
            // let total_sgst_amt = purchase_details.reduce((a, v) => a = a + parseFloat(v?.sgst_amount), 0);
            // let total_igst_amt = purchase_details.reduce((a, v) => a = a + parseFloat(v?.igst_amount), 0);

            let total_item_amount = sale_detail.reduce((total, obj) => parseFloat(obj?.item_value != undefined ? obj?.item_value : 0) + total, 0);
            let total_discount = sale_detail.reduce((total, obj) => parseFloat(obj?.discount != undefined ? obj?.discount : 0) + total, 0);
            let total_taxable_amount = sale_detail.reduce((total, obj) => parseFloat(obj?.taxable_amount != undefined ? obj?.taxable_amount : 0) + total, 0);
            let total_cgst_amt = sale_detail.reduce((total, obj) => parseFloat(obj?.cgst_amount != undefined ? obj?.cgst_amount : 0) + total, 0);
            let total_sgst_amt = sale_detail.reduce((total, obj) => parseFloat(obj?.sgst_amount  != undefined ? obj?.sgst_amount : 0) + total, 0);
            let total_igst_amt = sale_detail.reduce((total, obj) => parseFloat(obj?.igst_amount  != undefined ? obj?.igst_amount : 0) + total, 0);
            

            total_gst = parseFloat(total_cgst_amt) + parseFloat(total_sgst_amt) + parseFloat(total_igst_amt);
            total_amount_with_gst = total_gst + parseFloat(total_taxable_amount);

            const payableAmountDetail = commonUtility.getRoundOfAmount(total_amount_with_gst);

           

            const payableAmt = payableAmountDetail.newPayableAmount;
            const roundoff_amount = parseFloat(payableAmountDetail.roundoffAmount);



            setSummaryAmountDetails({
                totalAmount: !isNaN(total_item_amount) ? total_item_amount : 0 ,
                totalDiscount: !isNaN(total_discount) ? total_discount : 0 ,
                totalTaxable: !isNaN(total_taxable_amount) ? total_taxable_amount : 0 ,
                totalCGST: !isNaN(total_cgst_amt) ? total_cgst_amt : 0 ,
                totalSGST: !isNaN(total_sgst_amt) ? total_sgst_amt : 0 ,
                totalIGST: !isNaN(total_igst_amt) ? total_igst_amt : 0 ,
                totalGST: !isNaN(total_gst) ? total_gst : 0,
                totalNetAmountWithGST: !isNaN(total_amount_with_gst) ? total_amount_with_gst : 0,
                round_off_amount: !isNaN(roundoff_amount) ? roundoff_amount : 0,
                netAmountAfterRoundOff: !isNaN(payableAmt) ? payableAmt : 0,
            });


            form.setFieldsValue({
                total_amount : !isNaN(total_item_amount) ? total_item_amount : 0,
                total_discount : !isNaN(total_discount) ? total_discount : 0,
                total_taxable : !isNaN(total_taxable_amount) ? total_taxable_amount : 0,
                total_cgst: !isNaN(total_cgst_amt) ? total_cgst_amt : 0,
                total_sgst: !isNaN(total_sgst_amt) ? total_sgst_amt : 0,
                total_igst: !isNaN(total_igst_amt) ? total_igst_amt : 0,
                total_gst: !isNaN(total_gst) ? total_gst : 0,
                gst_including_amount: !isNaN(total_amount_with_gst) ? total_amount_with_gst : 0,
                round_off_amount: !isNaN(roundoff_amount) ? roundoff_amount : 0,
                net_amount: !isNaN(payableAmt) ? payableAmt : 0,
            });

           
            



    }



    const removeDetail = (index) => {
        const list = [...form.getFieldValue('sale_detail')];
        list.splice(index, 1);
        form.setFieldsValue({ sale_detail: list });
        onFormCalculation();
    }




    /**
     * onQtyChange
     * @param {*} e 
     * @param {*} v 
     * @param {*} index 
     */


    const calItemAmount = (e, v, index) => {

        const qty = form.getFieldValue(["sale_detail", index, "qty",]) > 0 ? form.getFieldValue(["sale_detail", index, "qty",]) : 0;
        const rate = form.getFieldValue(["sale_detail", index, "rate_per_unit",]) > 0 ? form.getFieldValue(["sale_detail", index, "rate_per_unit",]) : 0;
        const discount = form.getFieldValue(["sale_detail", index, "discount",]) > 0 ? form.getFieldValue(["sale_detail", index, "discount",]) : 0;

        const amount = parseFloat(qty) * parseFloat(rate);

        console.log('amount',amount);

        form.setFields([
            {
                name: ["sale_detail", index, "item_value"],
                value: amount,
            },
            {
                name: ["sale_detail", index, "taxable_amount"],
                value: amount - parseFloat(discount),
            }
        ]);


        const cgst_id = form.getFieldValue(["sale_detail", index, "cgst_id"]) != undefined ? form.getFieldValue(["sale_detail", index, "cgst_id"]) : 0;
        const sgst_id = form.getFieldValue(["sale_detail", index, "sgst_id"]) != undefined ? form.getFieldValue(["sale_detail", index, "sgst_id"]) : 0;
        const igst_id = form.getFieldValue(["sale_detail", index, "igst_id"]) != undefined ? form.getFieldValue(["sale_detail", index, "igst_id"]) : 0;

        const cgst_rate = form.getFieldValue(["sale_detail", index, "cgst_rate"]) != undefined ? form.getFieldValue(["sale_detail", index, "cgst_rate"]) : 0;
        const sgst_rate = form.getFieldValue(["sale_detail", index, "sgst_rate"]) != undefined ? form.getFieldValue(["sale_detail", index, "sgst_rate"]) : 0;
        const igst_rate = form.getFieldValue(["sale_detail", index, "igst_rate"]) != undefined ? form.getFieldValue(["sale_detail", index, "igst_rate"]) : 0;




        onGSTChange(index, { "type": "CGST", "value": cgst_id, "rate": cgst_rate }, index);
        onGSTChange(index, { "type": "SGST", "value": sgst_id, "rate": sgst_rate }, index);
        onGSTChange(index, { "type": "IGST", "value": igst_id, "rate": igst_rate }, index);


    }


    /**
     * 
     */

    const onDecriptionChange = (v, e, index) => {
        let hsn = e.hsn;
        form.setFields([
            {
                name: ["sale_detail", index, "hsn"],
                value: commonUtility.sanitizeObject(hsn),
            }
        ]);

    }

    /**
     * onGSTChange
     * @param {*} e 
     * @param {*} v 
     * @param {*} index 
     */
    const onGSTChange = (v, e, index) => {
        
        const gst_type = e.type;
        const gst_id = e.value;
        const gst_rate = e.rate;
        
        const amount = form.getFieldValue(["sale_detail", index, "taxable_amount",]) > 0 ? form.getFieldValue(["sale_detail", index, "taxable_amount",]) : 0;
        let gst_amount = (amount * gst_rate) / 100;
        
        resetGst(index, gst_type , gst_id);

        if (gst_type == "CGST") {
            form.setFields([
                {
                    name: ["sale_detail", index, "cgst_amount"],
                    value: gst_amount,
                }
            ]);
            form.setFields([
                {
                    name: ["sale_detail", index, "cgst_rate"],
                    value: gst_rate,
                }
            ]);
        }
        else if (gst_type == "SGST") {
            form.setFields([
                {
                    name: ["sale_detail", index, "sgst_amount"],
                    value: gst_amount,
                }
            ]);
            form.setFields([
                {
                    name: ["sale_detail", index, "sgst_rate"],
                    value: gst_rate,
                }
            ]);
        }
        else {
            form.setFields([
                {
                    name: ["sale_detail", index, "igst_amount"],
                    value: gst_amount,
                }
            ]);
            form.setFields([
                {
                    name: ["sale_detail", index, "igst_rate"],
                    value: gst_rate,
                }
            ]);
        }


        onCalculateBlockPayable(index);
    };


    /**
     * onCalculatePayable
     * @param {*} e 
     * @param {*} v 
     * @param {*} index 
     */

    const onCalculateBlockPayable = (index) => {

        let total_amount_with_gst = 0;
        let total_gst = 0;

        const amount = form.getFieldValue(["sale_detail", index, "item_value",]) > 0 ? form.getFieldValue(["sale_detail", index, "item_value",]) : 0;
        const cgst_amount = form.getFieldValue(["sale_detail", index, "cgst_amount",]) > 0 ? form.getFieldValue(["sale_detail", index, "cgst_amount",]) : 0;
        const sgst_amount = form.getFieldValue(["sale_detail", index, "sgst_amount",]) > 0 ? form.getFieldValue(["sale_detail", index, "sgst_amount",]) : 0;
        const igst_amount = form.getFieldValue(["sale_detail", index, "igst_amount",]) > 0 ? form.getFieldValue(["sale_detail", index, "igst_amount",]) : 0;

        total_gst = parseFloat(cgst_amount) + parseFloat(sgst_amount) + parseFloat(igst_amount);
        total_amount_with_gst = total_gst + parseFloat(amount);


        form.setFields([
            {
                name: ["sale_detail", index, "total_gst_amount"],
                value: total_gst.toFixed(2),
            }
        ]);

        form.setFields([
            {
                name: ["sale_detail", index, "net_amount"],
                value: total_amount_with_gst.toFixed(2),
            }
        ]);

        onFormCalculation();

    }


    const resetGst = (index, type , id) => {

        if (type == "IGST" && commonUtility.sanitizeValue(id) > 0) {
            form.setFields([{ name: ["sale_detail", index, "cgst_amount"], value: 0, }]);
            form.setFields([{ name: ["sale_detail", index, "cgst_rate"], value: 0, }]);
            form.setFields([{ name: ["sale_detail", index, "cgst_id"], value: "", }]);

            form.setFields([{ name: ["sale_detail", index, "sgst_amount"], value: 0, }]);
            form.setFields([{ name: ["sale_detail", index, "sgst_rate"], value: 0, }]);
            form.setFields([{ name: ["sale_detail", index, "sgst_id"], value: "", }]);
        }
        else {
            form.setFields([{ name: ["sale_detail", index, "igst_amount"], value: 0, }]);
            form.setFields([{ name: ["sale_detail", index, "igst_rate"], value: 0, }]);
            form.setFields([{ name: ["sale_detail", index, "igst_id"], value: "", }]);
        }

    }





    return (
        <div>
            <div className="form-input-style">
                <Row
                    className="login-first-step-row"
                    style={{ background: "transparent" }}
                >
                    <Col className="login-first-step-block-1" xs={24} xl={24}>
                        <Form
                            form={form}
                            layout="vertical"
                            onFinish={onTaxInvoiceSave}
                            autoComplete="off"
                            initialValues={defaultFormValues}
                            className="basicRegForm"
                            onFieldsChange={(event) => onFormCalculation()}
                            onValuesChange={(event) => onFormCalculation()}
                            onKeyUp={onFormCalculation}
                            onBlur={onFormCalculation}
                            style={{ padding: "10px 20px" }}
                        >

                            <Row gutter={20}>
                                <Col className="gutter-row" xs={24} xl={6}>
                                    <Form.Item name="invoice_number" label="Invoice No">
                                        <Input placeholder="" readOnly={true} />
                                    </Form.Item>

                                    <Form.Item name="mode" label="mode" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>

                                    <Form.Item name="salebill_id" label="" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>

                                    <Form.Item name="voucher_id" label="" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>

                                    <Form.Item name="total_taxable" label="" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>

                                    <Form.Item name="total_cgst" label="" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>

                                    <Form.Item name="total_sgst" label="" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>

                                    <Form.Item name="total_igst" label="" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>

                                    <Form.Item name="total_gst" label="" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>

                                    <Form.Item name="gst_including_amount" label="" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>
                                    <Form.Item name="round_off_amount" label="" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>
                                    <Form.Item name="round_off_account_id" label="" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>
                                    <Form.Item name="net_amount" label="" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>
                                    <Form.Item name="sale_detail" label="" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} xl={6}>
                                    <Form.Item name="invoice_date_picker" label="Invoice Date" rules={[
                                        {
                                            required: true,
                                            message: 'Invoice Date is required',
                                        },
                                    ]}>
                                        <DatePicker
                                            format="DD/MM/YYYY"
                                            // onChange={onDateOfBirthChange}
                                            onChange={onDateChange}
                                            style={{ width: "100%" }}
                                            inputReadOnly={true}
                                        />
                                    </Form.Item>
                                    <Form.Item name="invoice_date" label="Invoice Date" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>
                                </Col>




                                <Col xs={24} xl={6}>
                                    <Form.Item name="customer_account_id" label="Customer" rules={[
                                        {
                                            required: true,
                                            message: 'Customer is required',
                                        },
                                    ]}>
                                        {/* <Select className="text-left" defaultValue="0"> */}

                                        <Select
                                            showSearch
                                            placeholder="Search to Select"
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                                // option.children.includes(input)
                                                option.children.toLowerCase().includes(input.toLowerCase())
                                            }
                                            filterSort={(optionA, optionB) =>
                                                optionA.children
                                                    .toLowerCase()
                                                    .localeCompare(optionB.children.toLowerCase())
                                            }
                                            placement="bottomLeft"

                                            allowClear={true}

                                        >
                                            {
                                                customerList.length > 0 ?
                                                customerList.map(customer_data => (
                                                        <Option key={customer_data.account_master_id} value={customer_data.account_master_id}>{customer_data.account_name}</Option>

                                                    ))
                                                    : ''
                                            }
                                        </Select>
                                    </Form.Item>
                                </Col>

                                <Col xs={24} xl={6} hidden={true}>
                                    <Form.Item name="dr_ac_id" label="Account To be Debited" rules={[
                                        {
                                            required: false,
                                            message: 'Customer is required',
                                        },
                                    ]}>
                                        {/* <Select className="text-left" defaultValue="0"> */}

                                        <Select
                                            showSearch
                                            placeholder="Search to Select"
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                                // option.children.includes(input)
                                                option.children.toLowerCase().includes(input.toLowerCase())
                                            }
                                            filterSort={(optionA, optionB) =>
                                                optionA.children
                                                    .toLowerCase()
                                                    .localeCompare(optionB.children.toLowerCase())
                                            }
                                            placement="bottomLeft"

                                            allowClear={true}

                                        >
                                            {
                                                accountList.length > 0 ?
                                                    accountList.map(account_data => (
                                                        <Option key={account_data.id} value={account_data.id}>{account_data.account_name}</Option>

                                                    ))
                                                    : ''
                                            }
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>



                            <Row gutter={20}>
                                <Col xs={24} xl={24}>
                                    {/* <AccountDrCrDetails form={form} onDrCrCalculation={onDrCrCalculation} removeDetail={removeDetail} onDebitCreditChange={onDebitCreditChange} /> */}
                                    <TaxInvoiceDetailView form={form} removeDetail={removeDetail} calItemAmount={calItemAmount} onGSTChange={onGSTChange} onDecriptionChange={onDecriptionChange} />
                                </Col>
                            </Row>

                            {
                                /**Summary */
                            }

                            <Row gutter={20}>
                                <Col xs={24} xl={24}>
                                    <Card
                                        size="small"
                                        title="Amount Summary"
                                        style={{
                                            width: 300,
                                            float: 'right',
                                            fontWeight:'500'
                                        }}
                                    >
                                        <Row gutter={20}>
                                            <Col xs={24} xl={12} >Total Amount</Col>
                                            <Col xs={24} xl={12} align="right"><span>&#x20B9;</span> {summaryAmountDetails.totalAmount.toFixed(2)}</Col>
                                        </Row>
                                        <Divider dashed style={dividerStyle} />
                                        <Row gutter={20}>
                                            <Col xs={24} xl={12} >Total Discount</Col>
                                            <Col xs={24} xl={12} align="right"><span>&#x20B9;</span> {summaryAmountDetails.totalDiscount.toFixed(2)}</Col>
                                        </Row>
                                        <Divider dashed style={dividerStyle} />
                                        <Row gutter={20}>
                                            <Col xs={24} xl={12} >Total Taxable</Col>
                                            <Col xs={24} xl={12} align="right"><span>&#x20B9;</span> {summaryAmountDetails.totalTaxable.toFixed(2)}</Col>
                                        </Row>
                                        <Divider dashed style={dividerStyle} />
                                        <Row gutter={20}>
                                            <Col xs={24} xl={12} >Total CGST</Col>
                                            <Col xs={24} xl={12} align="right"><span>&#x20B9;</span> {summaryAmountDetails.totalCGST.toFixed(2)}</Col>
                                        </Row>
                                        <Divider dashed style={dividerStyle} />
                                        <Row gutter={20}>
                                            <Col xs={24} xl={12} >Total SGST</Col>
                                            <Col xs={24} xl={12} align="right"><span>&#x20B9;</span> {summaryAmountDetails.totalSGST.toFixed(2)}</Col>
                                        </Row>
                                        <Divider dashed style={dividerStyle} />
                                        <Row gutter={20}>
                                            <Col xs={24} xl={12} >Total IGST</Col>
                                            <Col xs={24} xl={12} align="right"><span>&#x20B9;</span> {summaryAmountDetails.totalIGST.toFixed(2)}</Col>
                                        </Row>
                                        <Divider dashed style={dividerStyle} />
                                        <Row gutter={20}>
                                            <Col xs={24} xl={12} >Total GST</Col>
                                            <Col xs={24} xl={12} align="right"><span>&#x20B9;</span> {summaryAmountDetails.totalGST.toFixed(2)}</Col>
                                        </Row>
                                        <Divider dashed style={dividerStyle} />
                                        <Row gutter={20}>
                                            <Col xs={24} xl={12} >Total GST + Amount</Col>
                                            <Col xs={24} xl={12} align="right"><span>&#x20B9;</span> {summaryAmountDetails.totalNetAmountWithGST.toFixed(2)}</Col>
                                        </Row>
                                        <Divider dashed style={dividerStyle} />
                                        <Row gutter={20}>
                                            <Col xs={24} xl={12} >Round Off</Col>
                                            <Col xs={24} xl={12} align="right"><span>&#x20B9;</span> {summaryAmountDetails.round_off_amount}</Col>
                                        </Row>
                                        <Divider dashed style={dividerStyle} />
                                        <Row gutter={20}>
                                            <Col xs={24} xl={12} >Total Net Amount (After round off)</Col>
                                            <Col xs={24} xl={12} align="right"><span>&#x20B9;</span> {summaryAmountDetails.netAmountAfterRoundOff.toFixed(2)}</Col>
                                        </Row>

                                    </Card>
                                </Col>
                            </Row>






                            <Row gutter={20}>
                                {/* <Col xs={24} xl={12} >
                                    {
                                        formErrorMessage.length > 0 ? <><Tag color="error">{formErrorMessage}</Tag></> : ''
                                    }

                                </Col> */}
                                <Col xs={24} xl={20}></Col>
                                <Col xs={24} xl={2} align="right">
                                    <Form.Item>
                                        {
                                            isSaveLoaderEnable ? <Spin /> : <>
                                                <Button htmlType="submit" className="custom-button-green" shape="round" style={{ margin: 8, border: 0 }}> Save <RightOutlined /></Button>
                                            </>
                                        }
                                    </Form.Item>
                                </Col>
                            </Row>





                        </Form>
                    </Col>

                </Row>
            </div>


            {/* <ModalWithMessageAndAction key={commonUtility.randomID()} responseModalTitle={responseModalTitle} openModal={openModal} handleCancel={handleCancel} listLink={'/journalvoucher/list'} addmoreLink={'/journalvoucher/entry'} responseModalMessage={responseModalMessage} /> */}
            {
                responseModal.isOpenModal ? <>
                    <ModalWithMessageAndAction responseModal={responseModal} />
                </> : <></>
            }

        </div>
    )
}

export default TaxInvoiceEntryView